// A lead's timeline, the email events. In its own file so the lead page only
// routes to it.

import { Link } from 'react-router-dom'
import type { LeadActivity } from '@/api/types'
import { gateReasonLabel, skipReasonLabel } from '@/lib/growthCampaigns'

function text(v: unknown): string {
  return typeof v === 'string' ? v : ''
}

function headline(item: LeadActivity): string {
  const d = item.detail
  const subject = text(d.subject)
  switch (item.kind) {
    case 'email_sent':
      return subject ? `Emailed: ${subject}` : 'Emailed'
    case 'email_dry_run':
      return `Dry run, nothing sent${subject ? `: ${subject}` : ''} (${gateReasonLabel(text(d.reason)) || 'sending is off'})`
    case 'email_skipped':
      return text(d.reason) === 'removed'
        ? 'Removed from the Schedule'
        : `${d.outreach_email_id ? 'One-off email not sent' : 'Email skipped'}: ${skipReasonLabel(text(d.reason))}`
    case 'email_clicked':
      return `Clicked ${text(d.url) || 'a link'}`
    case 'email_bounced':
      return `Email bounced (${text(d.kind) || 'hard'})`
    case 'email_replied':
      return text(d.source) === 'manual' ? 'Marked as replied' : 'Replied'
    case 'email_unsubscribed':
      return text(d.source) === 'reply' ? 'Asked to stop, in a reply' : 'Unsubscribed'
    default:
      return item.kind.replace(/_/g, ' ')
  }
}

export function EmailActivityText({ item }: { item: LeadActivity }) {
  const campaignId = Number(item.detail.campaign_id)
  const snippet = text(item.detail.snippet)
  return (
    <div className="grid gap-0.5">
      <p className="break-words text-[13.5px] text-ink">{headline(item)}</p>
      {/* A stranger's words, shown as text. */}
      {snippet ? <p className="break-words text-[13px] text-muted">“{snippet}”</p> : null}
      {Number.isInteger(campaignId) && campaignId > 0 ? (
        <Link to={`/growth/campaigns/${campaignId}`} className="text-xs text-muted underline underline-offset-2 hover:text-accent">
          View campaign
        </Link>
      ) : null}
    </div>
  )
}
